import { ICheckFlagNameExists, ISystemFlagTagType, IUpdateStatusType } from "../types"
const systemFlagBaseUrl = '/systemflag'
export const SystemFlagEndpointConst = {
    getSystemFlags: `${systemFlagBaseUrl}/list`,
    addSystemFlag: `${systemFlagBaseUrl}/add`,
    addEditSystemFlagUrl: `${systemFlagBaseUrl}`,
    deleteSystemFlagUrl: `${systemFlagBaseUrl}`,
}

export const updateSystemFlagStatus = (params: IUpdateStatusType) => {
    return `systemflag/${params.id}/status/${params.status}`
}

export const checkFlagNameExists = (params: ICheckFlagNameExists) => {
    return `${systemFlagBaseUrl}/${params.flagName}/exists`
}

export const getSystemFlagByTags = (params: ISystemFlagTagType) => {
    return `${systemFlagBaseUrl}/list/${params.tag}`
}